import isEqual from 'react-fast-compare';
export var depsEqual = function (aDeps, bDeps) {
    if (aDeps === void 0) { aDeps = []; }
    if (bDeps === void 0) { bDeps = []; }
    return isEqual(aDeps, bDeps);
};
